import { Injectable } from '@angular/core';
import { Badge } from 'src/app/entity/badge';
import { AngularFireList, AngularFireDatabase } from 'angularfire2/database';
import { HttpClient } from '@angular/common/http';
import { Delegate } from 'src/app/entity/Delegate';

@Injectable({
  providedIn: 'root'
})
export class SonatrachService {
 

  badges: AngularFireList<any>;
 

  constructor(private db: AngularFireDatabase,private http: HttpClient) {
 
 
    this.badges = db.list<Badge>("sonatrach", ref => ref.orderByKey() );
 
 
  }
 
  getAllBadges(){
   return this.badges.valueChanges();
  }
 
 
 addBadge(badge:Badge) {
  
  var dirChatRef =this.badges.push(badge)
  badge.id=dirChatRef.key;
   this.badges.update(dirChatRef.key,badge);
   } 


 updateBadge(uid:string,badge:Badge) {
    
     this.badges.update(uid,badge);
     } 
    removeBadge(uid:string ) {
    
      this.badges.remove(uid );
      } 
      getAllBadgesNotImported( ) {
        let users: AngularFireList<Badge>  ;
        users=this.db.list("sonatrach/",   ref => 
         ref.orderByChild('imported').equalTo(null));


         return users.valueChanges();
           
       
        }
        copyFromBadg(badge:Badge  ) : Delegate {
          let delegate =new Delegate();
           delegate.nom= badge.prenom+" "+badge.nom;
 
           delegate.mobile=badge.mobile;
           delegate.position=badge.position;
           delegate.mail=badge.mail;
           delegate.description=badge.typeBadge;
           delegate.uid='Sonatrach'

           delegate.entreprise=badge.filiale;
       
 
          
          return delegate;
           }

}
